LS.util.route({
	'loan-calculator': {
		':load': 'loan',
		':unload': 'loan:unload'
	}
});